/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import BorderRandomizer from './BorderRandomizer';
import { borderNotebook } from '../icons/borders';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/notebook-card.scss';

const propTypes = {
    id: PropTypes.number,
    title: PropTypes.string,
    description: PropTypes.string,
    url: PropTypes.string,
    image: AppPropTypes.image,
    dateStart: PropTypes.string,
    className: PropTypes.string,
    linkClassName: PropTypes.string,
};

const defaultProps = {
    id: null,
    title: null,
    description: null,
    url: null,
    image: null,
    dateStart: null,
    className: null,
    linkClassName: null,
};

const NotebookCard = ({
    id,
    title,
    description,
    url,
    image,
    dateStart,
    className,
    linkClassName,
}) => {
    if (id === null) {
        return null;
    }
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.withoutImage]: image === null,
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.inner}>
                <BorderRandomizer
                    seed={`notebook-${id}`}
                    borders={borderNotebook}
                    className={styles.randomBorder}
                />
                <Link
                    className={classNames([
                        styles.link,
                        {
                            [linkClassName]: linkClassName !== null,
                        },
                    ])}
                    to={url}
                >
                    {image ? (
                        <div
                            className={styles.image}
                            style={{
                                backgroundImage: `url('${image ? image.sizes.large : null}')`,
                            }}
                        />
                    ) : null}
                    <div className={styles.info}>
                        <h3 className={styles.title}>{title}</h3>
                        <p className={styles.dates}>
                            <span>{dateStart}</span>
                        </p>
                        <p className={styles.description}>{description}</p>
                    </div>
                </Link>
                <BorderRandomizer
                    seed={`notebook-${id + 1}`}
                    borders={borderNotebook}
                    className={styles.randomBorder}
                />
            </div>
        </div>
    );
};

NotebookCard.propTypes = propTypes;
NotebookCard.defaultProps = defaultProps;

export default NotebookCard;
